import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import BestProductManager from '../components/BestProductManager';
import { T } from '../styles/theme';

export default function CollaboratorePage() {
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/auth/me').then((r) => {
      if (r.data.ruolo !== 'collaboratore' && r.data.ruolo !== 'admin') navigate('/dashboard');
    }).catch(() => navigate('/login'));
  }, [navigate]);

  const handleLogout = () => { localStorage.removeItem('token'); navigate('/login'); };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: T.bg }}>
      <div style={{ borderBottom: `1px solid ${T.border}` }}>
        <div style={{ maxWidth: 1000, margin: '0 auto', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', background: T.gradPrimary }}>
              <span style={{ color: 'white', fontFamily: T.fontDisplay, fontWeight: 800, fontSize: '0.85rem' }}>IE</span>
            </div>
            <div>
              <h1 style={{ fontFamily: T.fontDisplay, fontSize: '1.1rem', fontWeight: 700, color: T.violet }}>Gestione Best Product</h1>
              <p style={{ fontFamily: T.fontBody, fontSize: '0.7rem', color: T.muted }}>Pannello Collaboratore</p>
            </div>
          </div>
          <button onClick={handleLogout} className="btn-danger" style={{ padding: '8px 16px', fontSize: '0.85rem' }}>Esci</button>
        </div>
      </div>
      <main style={{ maxWidth: 1000, margin: '0 auto', padding: '32px 24px' }}>
        <BestProductManager />
      </main>
    </div>
  );
}
